import { createContext } from 'react';
import { useConstraintsQuery } from 'hooks/webapi';
import type { Constraints } from 'hooks/webapi/application/useConstraintsQuery';
import { useClientConstraintsQuery } from 'hooks/webapi/application/useUpsale';
import { useSession } from 'session';

type ConstraintsContextType = {
  constraints?: Constraints;
  isLoading: boolean;
};

// eslint-disable-next-line react-refresh/only-export-components
export const ConstraintsContext = createContext<ConstraintsContextType>(
  {} as ConstraintsContextType,
);

function useConstraintsValue() {
  const tokenExists = useSession((state) => state.status === 'authenticated');

  const { data: constraintsData, isLoading: constraintsIsLoading } =
    useConstraintsQuery(!tokenExists);
  const { data: clientConstraintsData, isLoading: clientConstraintsIsLoading } =
    useClientConstraintsQuery(tokenExists);

  return {
    constraints: tokenExists ? clientConstraintsData : constraintsData,
    isLoading: tokenExists ? clientConstraintsIsLoading : constraintsIsLoading,
  };
}

export default function ConstraintsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ConstraintsContext.Provider value={useConstraintsValue()}>
      {children}
    </ConstraintsContext.Provider>
  );
}
